<template>
    <ContentOrLoading>
        <div class="row" v-if="! loading">
            <div class="col-12 text-center p-3">
                <LeafletComponent
                    :svgRendered="svgRendered"
                    :originalColor="originalColor"
                    @isPanning="(e) => isPanning = e"
                />
            </div>
        </div>
    </ContentOrLoading>
</template>

<script>
    import LeafletComponent from '@/components/svg/components/LeafletComponent.vue';
    import { Popover } from 'bootstrap';

    export default {
        props: ['plazas', 'zonas', 'recinto_id', 'evento_id', 'sesion_id', 'plazasSeleccionadas'],
        data() {
            return {
                svg_loaded : '',
                loading: true,
                svgpanzoom: null,
                svg: null,
                originalColor: '#0CBA31',
                noDisponibleColor: 'gray',
                ocupadaColor: 'red', 
                seleccionadaColor: '#8CA9D9',
                bloqueadaColor: '#BF95C4', 
                enSesionColor: 'orange', 
                vendidaAbonosColor: 'black',
                vendidaEventosColor: 'red',
                bloqueadaAbonoColor: 'purple', 
                enSesionEventosColor: 'yellow', 
                abonadoNoRenovadoColor: '#B05D04',
                validadaControlAccesoColor: '#01018A',
                svgRendered: null,
                isPanning: false
            }            
        },
        created() {
            this.getSvg();        
        },
        methods: {
            getSvg() {
                this.loading = true;
                const params = {
                    recinto_id: this.recinto_id
                };
                this.$store.dispatch(this.config.getVuexAlias('front.recinto.svg'), params)
                    .then(({ data: { svg } }) => {
                        this.renderLeafletSvg(svg);
                        this.loading = false;
                    }).catch(error => {
                        console.log(error);
                        console.warn('Error al recuperar el SVG del recinto anexo');
                    });
            },
            renderLeafletSvg(svg) {
                const plazasFiltered = this.plazas.filter(plaza => plaza.svg_id);
                const regionesFiltered = this.zonas.filter(region => region.svg_id);
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = svg;

                const svgElement = tempDiv.firstElementChild;
                const butacas = svgElement.querySelectorAll('[id^="butaca"]');
                const regiones = svgElement.querySelectorAll('[id^="region"]');

                butacas.forEach(circle => {
                    circle.setAttribute('seleccionado', 'false');
                    const svg_id = this.getButacaId(circle);
                    const plaza = plazasFiltered.find(plaza => plaza.svg_id == svg_id);
                    if (plaza) {
                        const title = this.getButacaName(plaza);
                        if (plaza.libre && !plaza.ocupada.bloqueada) {     
                            this.drawPopover(circle, plaza, title);      
                            circle.style.cursor = 'pointer';
                            circle.style.transition = 'fill 0.2s';
                            circle.setAttribute('fill', this.originalColor);

                            circle.addEventListener('click', () => {
                                let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));

                                setTimeout(() => {
                                    if (!this.isPanning) {
                                        if (!isSeleccionado) {
                                            circle.setAttribute('fill', this.seleccionadaColor);
                                            circle.setAttribute('seleccionado', 'true');
                                        } else {
                                            circle.setAttribute('fill', this.originalColor);
                                            circle.setAttribute('seleccionado', 'false');
                                        }
                                        this.clickButaca(plaza.id);
                                    }
                                }, 150);
                            });                    
                        } else {
                            if (plaza.ocupada.bloqueada) {
                                if (plaza.info_ocupada.concepto) {
                                    if(this.isMobile){
                                        return;
                                    }
                                    new Popover(circle, {
                                        html: true,
                                        title: title,
                                        content: '<div><strong>Concepto: </strong>' + plaza.info_ocupada.concepto + '</div>',
                                        trigger: 'hover'
                                    });
                                }
                                this.drawPopover(circle, plaza, title);      
                                circle.setAttribute('fill', this.bloqueadaColor);
                                circle.addEventListener('click', () => {
                                    let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));
    
                                    setTimeout(() => {
                                        if (!this.isPanning) {
                                            if (!isSeleccionado) {
                                                circle.setAttribute('fill', this.seleccionadaColor);
                                                circle.setAttribute('seleccionado', 'true');
                                            } else {
                                                if (plaza.etiqueta_bloqueo) {
                                                    circle.setAttribute('fill', plaza.etiqueta_bloqueo.color);
                                                } else {
                                                    circle.setAttribute('fill', this.bloqueadaColor);
                                                }
                                                circle.setAttribute('seleccionado', 'false');
                                            }
                                            this.clickButaca(plaza.id);
                                        }
                                    }, 150);
                                });

                                if (plaza.etiqueta_bloqueo) {
                                    circle.setAttribute('ocupada', 'true');
                                    circle.setAttribute('fill', plaza.etiqueta_bloqueo.color);
                                    this.drawPopover(circle, plaza, title); 
                                }
                            } else if (plaza.ocupada && plaza.ocupada.sesion) {
                                circle.setAttribute('ocupada', 'true');
                                circle.style.cursor = 'not-allowed';
                                circle.setAttribute('fill', this.enSesionEventosColor);
                                this.drawPopover(circle, plaza, title); 
                            }  else if (plaza.ocupada && plaza.ocupada.venta && plaza.info_acceso && plaza.info_acceso.accedido) {
                                circle.setAttribute('ocupada', 'true');
                                circle.setAttribute('fill', this.validadaControlAccesoColor);
                                circle.style.cursor = 'not-allowed';
                                this.drawPopover(circle, plaza, title); 
                            }  else if (plaza.ocupada && plaza.ocupada.venta) {
                                circle.setAttribute('ocupada', 'true');
                                circle.setAttribute('fill', this.vendidaEventosColor);
                                circle.style.cursor = 'not-allowed';
                                this.drawPopover(circle, plaza, title); 
                            } else if (plaza.ocupada && plaza.ocupada.bloqueada_abonos) {
                                circle.setAttribute('ocupada', 'true');
                                circle.setAttribute('fill', this.bloqueadaAbonoColor);
                                circle.style.cursor = 'not-allowed';
                                this.drawPopover(circle, plaza, title); 
                            } else if (plaza.ocupada && plaza.ocupada.comprada_abonos && plaza.ocupada.renovado) {
                                circle.setAttribute('ocupada', 'true');
                                circle.setAttribute('fill', this.vendidaAbonosColor);
                                circle.style.cursor = 'not-allowed';

                                let content

                                if (plaza.info_ocupada.numero_pedido) {
                                    circle.style.cursor = 'pointer';
                                    content = '<div><strong>Nº del pedido: </strong>' + plaza.info_ocupada.numero_pedido + '</div>';

                                    circle.addEventListener('click', () => {
                                        let url = `/admin/eventos/${this.evento_id}/sesiones/${this.sesion_id}/ventas?n_pedido=${plaza.info_ocupada.numero_pedido}`;
                                        window.open(url, '_blank');
                                    });
                                }
                                this.drawPopover(circle, plaza, title, content); 
                            } else if (plaza.ocupada && plaza.ocupada.comprada_abonos && !plaza.ocupada.renovado) {
                                circle.setAttribute('ocupada', 'true');
                                circle.setAttribute('fill', this.abonadoNoRenovadoColor);
                                circle.style.cursor = 'not-allowed';

                                let content

                                if (plaza.info_ocupada.numero_pedido) {
                                    circle.style.cursor = 'pointer';
                                    content = '<div><strong>Nº del pedido: </strong>' + plaza.info_ocupada.numero_pedido + '</div>';

                                    circle.addEventListener('click', () => {
                                        let url = `/admin/eventos/${this.evento_id}/sesiones/${this.sesion_id}/ventas?n_pedido=${plaza.info_ocupada.numero_pedido}`;
                                        window.open(url, '_blank');
                                    });
                                }
                                this.drawPopover(circle, plaza, title, content); 
                            }  else if (plaza.ocupada && plaza.ocupada.en_sesion_abonos) {
                                circle.setAttribute('ocupada', 'true');
                                circle.setAttribute('fill', this.enSesionColor);
                                circle.style.cursor = 'not-allowed';
                                this.drawPopover(circle, plaza, title); 
                            }
                        }
                    }
                });
            
                regiones.forEach(element => {
                    const svg_id = this.getButacaId(element);
                    const region = regionesFiltered.find(region => region.svg_id == svg_id);

                    if (region) {
                        if (region.esta_disponible) {
                            element.setAttribute('fill', this.originalColor);
                        }
                        if (!region.esta_disponible) {
                            element.setAttribute('fill', this.vendidaEventosColor);
                        }
                        element.addEventListener('click', () => {
                            const popover = document.querySelector('.popover');
                            if (popover) {
                                popover.remove();
                            }
                            this.clickRegion(region.id)
                        })
                        new Popover(element, {
                            html: true,
                            title: region.name,
                            content: `<div><strong>Asientos libres:</strong> ${region.esta_disponible ? 'Sí' : 'No'}</div>`,
                            trigger: 'hover'
                        });
                    }
                });

                this.svgRendered = tempDiv.firstElementChild;
            },
            drawPopover(circle, plaza, title = null, content = '') {
                if(this.isMobile){
                    return;
                }

                if (plaza.ocupada) {
                    if (plaza.etiqueta_bloqueo) {
                        content += `<div><strong>` + plaza.etiqueta_bloqueo.name + `</strong></div>`
                    }
                    if (plaza.ocupada.bloqueada) {
                        content += `<div><strong>Plaza bloqueada</strong></div>`;
                    }
                    if (plaza.ocupada.venta) {
                        content += `<div><strong>Vendida</strong></div>`;
                    }
                    if (plaza.ocupada.sesion) {
                        content += `<div><strong>En sesión</strong></div>`;
                    }
                    if (plaza.ocupada.comprada_abonos) {
                        content += `<div><strong>Vendida en abono</strong></div>`;
                    }
                    if (plaza.ocupada.bloqueada_abonos) {
                        content += `<div><strong>Bloqueada en abonos</strong></div>`;
                    }
                    if (plaza.ocupada.en_sesion_abonos) {
                        content += `<div><strong>En sesión en abono</strong></div>`;
                    }
                    if (plaza.ocupada.comprada_abonos && !plaza.ocupada.renovado) {
                        content += `<div><strong>Abonado no renovado</strong></div>`;
                    }
                    if (plaza.ocupada.venta) {
                        if (plaza.info_ocupada.numero_pedido) {
                            circle.style.cursor = 'pointer';
                            content += '<div><strong>Nº del pedido: </strong>' + plaza.info_ocupada.numero_pedido + '</div>';

                            if(plaza.info_acceso.accedido){
                                content += '<div><strong>Hora de acceso: </strong>' + plaza.info_acceso.hora_acceso + '</div>';
                            }

                            circle.addEventListener('click', () => {
                                let url = `/admin/eventos/${this.evento_id}/sesiones/${this.sesion_id}/ventas?n_pedido=${plaza.info_ocupada.numero_pedido}`;
                                window.open(url, '_blank');
                            });
                        }

                    }
                    if (plaza.ocupada.venta) {
                        content += `<div><strong>Nombre: </strong>${plaza.info_ocupada.nombre_venta + ' ' + plaza.info_ocupada.apellidos_venta}</div>`;
                    }
                }

                if (plaza.libre) {
                    content = `<div><strong>Plaza libre</strong></div>`;
                }

                const popoverOptions = {
                    title: title,
                    content: content,
                    trigger: 'hover',
                    html: true
                };

                new Popover(circle, popoverOptions);
            },

            getButacaId(circle) {
                const id = circle.id;
                const idParts = id.split("-");

                return idParts[1];
            },
            getButacaName(butaca) {
                const nButaca = butaca.butaca;
                const nFila = butaca.fila;
                const sector = butaca.sector_name;
                const visibilidad_reducida = butaca.visibilidad_reducida;
                const porcentaje_visibilidad = butaca.porcentaje_visibilidad;
                let name = '';

                if (sector) {
                    name += `Sector: ${sector} - `;
                }

                if (!nButaca && !nFila) {
                    name += `Plaza: ${butaca.numero}`;
                } else {
                    name += `Fila: ${nFila} - Butaca: ${nButaca}`;
                }

                if (visibilidad_reducida) {
                    name += '<span class="text-danger"> Visibilidad Reducida</span>';
                }

                if (porcentaje_visibilidad) {
                    name += `<span class="text-danger">: ${porcentaje_visibilidad} %</span>`;
                }

                return name;
            },

            clickButaca(plaza_id) {
                let plaza = this.plazas.find(plaza => plaza.id == plaza_id);
                if (plaza) {
                    this.$emit('clickPlaza', plaza);
                }
            },
            clickRegion(region_id) {
                let region = this.zonas.find(region => region.id == region_id);
                if (region) {
                    this.$emit('clickZona', 0, region);
                }
            },
        },
        watch: {
            clonedPlazasSeleccionadas(newValue, oldValue) {
                this.plazas.forEach(plaza => {
                    const circle = document.querySelector(`[id^="butaca-${plaza.svg_id}-"]`);

                    if (circle) {
                        if (plaza.disponible) {
                            if (newValue && newValue.find(p => p.id == plaza.id)) {
                                circle.setAttribute('fill', this.seleccionadaColor);
                                circle.setAttribute('seleccionado', 'true');
                            } else {
                                circle.setAttribute('fill', this.originalColor);
                                circle.setAttribute('seleccionado', 'false');
                            }
                        }
                    }
                });
            }
        },
        computed: {
            clonedPlazasSeleccionadas() {
                return this.plazasSeleccionadas ? [...this.plazasSeleccionadas] : null;
            },
            isMobile() {
                return window.innerWidth <= 768
            },
        },
        components: { LeafletComponent }
    }
</script>